import { render, staticRenderFns } from "./UserFormSubscribedSectors.vue?vue&type=template&id=56ec517c"
import script from "./UserFormSubscribedSectors.vue?vue&type=script&lang=js"
export * from "./UserFormSubscribedSectors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56ec517c')) {
      api.createRecord('56ec517c', component.options)
    } else {
      api.reload('56ec517c', component.options)
    }
    module.hot.accept("./UserFormSubscribedSectors.vue?vue&type=template&id=56ec517c", function () {
      api.rerender('56ec517c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/User/Form/UserFormSubscribedSectors.vue"
export default component.exports